export const initialState = {
    dateRangeStart: null,
    dateRangeEnd: null,
    category: '',
    amenity: '',
    searchTerm: '',
    status: 'all',
    multiFilter: [],
};

// Booking list filter action
export const BOOKINGS_DATE_FILTER_CHANGE = 'bookings/list/BOOKINGS_DATE_FILTER_CHANGE';
export const BOOKINGS_SEARCH_TERM_CHANGE = 'bookings/list/BOOKINGS_SEARCH_TERM_CHANGE';
export const BOOKINGS_CATEGORY_FILTER_CHANGE = 'bookings/list/BOOKINGS_CATEGORY_FILTER_CHANGE';
export const BOOKINGS_AMENITY_FILTER_CHANGE = 'bookings/list/BOOKINGS_AMENITY_FILTER_CHANGE';
export const BOOKINGS_STATUS_FILTER_CHANGE = 'bookings/list/BOOKINGS_STATUS_FILTER_CHANGE';
export const BOOKINGS_MULTIFILTER_CHANGE = 'bookings/list/BOOKINGS_MULTIFILTER_CHANGE';
export const BOOKINGS_FILTERS_CLEARED = 'bookings/list/BOOKINGS_FILTERS_CLEARED';

export const dateFilterChanged = (startDate, endDate) => ({
    type: BOOKINGS_DATE_FILTER_CHANGE,
    payload: {
        start: startDate,
        end: endDate
    }
});

export const searchTermChanged = (term) => ({
    type: BOOKINGS_SEARCH_TERM_CHANGE,
    payload: term
});

export const categoryFilterChanged = (category) => ({
    type: BOOKINGS_CATEGORY_FILTER_CHANGE,
    payload: category
});

export const amenityFilterChanged = (amenity) => ({
    type: BOOKINGS_AMENITY_FILTER_CHANGE,
    payload: amenity
});

export const statusFilterChanged = (status) => ({
    type: BOOKINGS_STATUS_FILTER_CHANGE,
    payload: status,
});

export const multiFilterChanged = (multiFilterSelection) => ({
    type: BOOKINGS_MULTIFILTER_CHANGE,
    payload: multiFilterSelection,
})

export const clearFilters = () => ({
    type: BOOKINGS_FILTERS_CLEARED
})

export const FiltersReducer = (state = {...initialState}, action) => {
    switch (action.type) {
        case BOOKINGS_DATE_FILTER_CHANGE: {
            return {
                ...state,
                dateRangeStart: action.payload.start,
                dateRangeEnd: action.payload.end
            }
        }

        case BOOKINGS_SEARCH_TERM_CHANGE: {
            return {
                ...state,
                searchTerm: action.payload
            }
        }

        case BOOKINGS_CATEGORY_FILTER_CHANGE: {
            let newAmenity = (action.payload !== state.category) ? null : state.amenity;

            return {
                ...state,
                category: action.payload,
                amenity: newAmenity,
            }
        }

        case BOOKINGS_AMENITY_FILTER_CHANGE: {
            return {
                ...state,
                amenity: action.payload
            }
        }

        case BOOKINGS_STATUS_FILTER_CHANGE: {
            return {
                ...state,
                status: action.payload,
            }
        }

        case BOOKINGS_MULTIFILTER_CHANGE: {
            return {
                ...state,
                multiFilter: action.payload,
            }
        }

        case BOOKINGS_FILTERS_CLEARED: {
            return initialState
        }

        default:
            return state;
    }
};
